/**
 * Details_B17 / Numbers_in_speech: announce numeric identifiers digit-by-digit
 * (e.g. folio, account, PIN) instead of as whole quantities (billion, million).
 */
export function formatDigitsForSpeech(value: string | number | null | undefined): string {
  if (value == null) return ''
  return String(value)
    .split('')
    .join(' ')
}
